import React, { Component, ReactNode } from 'react';
import Template from '../components/Template/Template';
interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("Error caught by Error Boundary:", error, info);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <Template>        
          <section className="page-section">
        <div className="full-width-screen">
            <div className="container-fluid">
                <div className="content-detail">
                    <h1 className="global-title"><span>400</span></h1>

                    <h4 className="sub-title">Oops!</h4>

                    <p className="detail-text">Sorry Bad Request, <br/>The HTTP request that was sent to the server has invalid syntax.</p> 

                    <div className="back-btn">
                        <a href="/" className="btn">Back to Home</a>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </Template>

      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
